export const REQUEST_CONFIG = 'REQUEST_CONFIG'
export const REQUEST_CONFIG_SUCESS = 'REQUEST_CONFIG_SUCESS'
export const REQUEST_CONFIG_ERROR = 'REQUEST_CONFIG_ERROR'

export const TEMPLATE_MESSAGES_SUCESS = 'TEMPLATE_MESSAGES_SUCESS'
export const NEW_TEMPLATE_MESSAGE_DATA = 'NEW_TEMPLATE_MESSAGE_DATA'

export const LOAD_TEMPLATE_MESSAGE = 'LOAD_TEMPLATE_MESSAGE'